import {Col, Row} from "react-bootstrap";
import styles from './Footer.module.css';

export const Footer = () => {
    return (
        <Row>
            <Col className={styles.footer}>Copyright &copy; TFSoft 2022 v4.1.0</Col>
        </Row>
    );
}
